<template>
<div class="hg-entity">
    <select class="hg-select" 
            v-model="value"
            :disabled="disabled"
            @change="onChange($event)"
            :readonly="schema.readonly">
        <option v-for="opt in values" :key="opt.id" :value="opt.id">{{opt.name}}</option>
    </select>
</div>
</template>

<script>
   import { abstractField } from "vue-form-generator";

   export default {
        mixins: [ abstractField ],
        mounted(){
            if(Array.isArray(this.schema.values)){
                this.values = this.schema.values;
            }else if(this.schema.values instanceof Promise){
                var self = this;
                this.schema.values.then(function(response){
                    if(Array.isArray(response)){
                        self.values = response;
                    }else if(Array.isArray(response.entries)){
                        self.values = response.entries;
                    }else{
                        console.error("NO ARRAY", response)
                    }
                })
            }

        },
        data(){
            return {
                values: []
            }
        },
        methods: {
            onChange: function(event){
                this.$emit('input', event.target.value)
            }
        }
   };
</script>